import { Tag } from "@chakra-ui/react";

export const GenreTags = ({ genre, idx }) => {
  return (
    <Tag fontSize="xs" ml={idx !== 0 ? "3" : "0"}>
      {genre}
    </Tag>
  );
};
